import {LABORATORY_CREATE, LABORATORY_UPDATE, LABORATORY_DELETE,
        REACTION_CREATE, REACTION_UPDATE, REACTION_DELETE,
        STAIN_CREATE, STAIN_UPDATE, STAIN_DELETE,
        SLIDE_SERVICE_CREATE, SLIDE_SERVICE_UPDATE, SLIDE_SERVICE_DELETE} from './available'
import _ from 'lodash'

export default {
  [LABORATORY_CREATE](state, item) {
    state.availableLaboratories.push(item)
  },
  [LABORATORY_UPDATE](state, item) {
    let itemIndex = _.findIndex(state.availableLaboratories, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableLaboratories.splice(itemIndex, 1, item)
  },
  [LABORATORY_DELETE](state, item) {
    let itemIndex = _.findIndex(state.availableLaboratories, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableLaboratories.splice(itemIndex, 1)
  },
  [REACTION_CREATE](state, item) {
    state.availableReactions.push(item)
  },
  [REACTION_UPDATE](state, item) {
    let itemIndex = _.findIndex(state.availableReactions, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableReactions.splice(itemIndex, 1, item)
  },
  [REACTION_DELETE](state, item) {
    let itemIndex = _.findIndex(state.availableReactions, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableReactions.splice(itemIndex, 1)
  },
  [STAIN_CREATE](state, item) {
    state.availableStains.push(item)
  },
  [STAIN_UPDATE](state, item) {
    let itemIndex = _.findIndex(state.availableStains, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableStains.splice(itemIndex, 1, item)
  },
  [STAIN_DELETE](state, item) {
    let itemIndex = _.findIndex(state.availableStains, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableStains.splice(itemIndex, 1)
  },
  [SLIDE_SERVICE_CREATE](state, item) {
    state.availableSlideService.push(item)
  },
  [SLIDE_SERVICE_UPDATE](state, item) {
    let itemIndex = _.findIndex(state.availableSlideService, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableSlideService.splice(itemIndex, 1, item)
  },
  [SLIDE_SERVICE_DELETE](state, item) {
    let itemIndex = _.findIndex(state.availableSlideService, function(i) {
      return i.id === item.id
    })

    if (itemIndex < 0) {
      return
    }

    state.availableSlideService.splice(itemIndex, 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/references.js